import React, { Component } from 'react'
import parse from 'html-react-parser'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'

import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import Fade from 'react-reveal/Fade'
import Slider from "react-slick"
import Plyr from './plyr';
import ApplicationGallery from './application-gallery'

// import { DownArrow} from './icons'

const carouselSettings = {
  ref: 'slider',
  infinite: true,
  slidesToShow: 1,
  arrows: true,
  dots: true,
  responsive: [
    {
      breakpoint: 768,
      settings: {
        infinite: false,
        arrows: false,
        slidesToShow: 1,
      }
    },
    {
      breakpoint: 480,
      settings: {
        infinite: false,
        arrows: false,
        slidesToShow: 1
      }
    }
  ]
}



class TabbedContent extends Component {

  state = {
    sort: 1,
    variant: 0,
    modal: false,
    select: false,
    image: null,
  }

  renderTab = (el, i) => {
    const param = el?.fieldGroupName?.split('_Acf_ContentBlocks_TabbedContent_Tabs_')[1]

    const block = {
      'CarouselContent': this.CarouselContent,
      'AccordianContent': this.AccordianContent,
      'IconsGrid': this.IconsGrid,
      'Video': this.Video,
      'ColumnContent': this.ColumnContent,
      'ApplicationGallery': this.ApplicationGallery
    }[param]

    if (!block) return null

    return block(el, i)
  }

  CarouselContent = ({ carousel, content, alignment }, index) => (
    <div className={`row row--${alignment}`} key={index}>
      <div className='row__col'>
        <div className='row__content'>
          {content && parse(content)}
        </div>
      </div>

      <div className='row__col'>

        {carousel?.length > 1 &&
          <Slider {...carouselSettings}>
            {carousel?.map((el, i) => {
              return (
                <div className='gallery' key={i}>
                  <GatsbyImage image={getImage(el.localFile)} alt={el?.altText} />

                  {el.caption && (
                    <>
                      <div className='gallery__caption__gradient'></div>
                      <div className='gallery__caption'>
                        <span>
                          {parse(el.caption)}
                        </span>
                      </div>
                    </>
                  )}

                </div>
              )
            })}
          </Slider>
        }

        { carousel?.length === 1 && (
          <div className='gallery'>
            <GatsbyImage image={getImage(carousel[0].localFile)} alt={carousel[0]?.altText} />
            {carousel[0].caption && (
              <>
                <div className='gallery__caption__gradient'></div>
                <div className='gallery__caption'>
                  <span>
                    {parse(carousel[0].caption)}
                  </span>
                </div>
              </>
            )}
          </div>
        )}

      </div>
    </div>
  )

  AccordianContent = ({ accordian, content, alignment }, index) => (
    <div className={`row row--${alignment}`}>
      <div className='row__col'>
        <div className='row__content'>
          {content && parse(content)}
        </div>
      </div>

      <div className='row__col'>

        <div className='tabs'>
          {accordian?.map((el, i) => (
            <div className="tab" key={i}>
              <input type="radio" id={i} name='ac' />
              <label className="tab-label" htmlFor={i}> <span>{i + 1}</span> {el.title}</label>
              <div className="tab-content">
                {el.content && <p>{parse(el.content)}</p>}
              </div>
            </div>
          ))
          }
        </div>

      </div>
    </div>
  )

  IconsGrid = ({ items }, index) => (
    <div className='row__icon-list'>
      {items?.map((el, i) => (
        <div className='row__icon-list--item' key={i}>
          { el.icon?.localFile && <GatsbyImage image={getImage(el.icon.localFile)} alt='HeadLand' /> }
          {el.title &&
            <>
              <div className='details'>
                {el.title && <h3>{el.title}</h3>}
                {el.subtitle && <span>{el.subtitle}</span>}
              </div>
            </>
          }
        </div>
      ))}
    </div>
  )

  Video = ({ video }, index) => (
    <div className='row__video'>
      <Plyr
        provider={video.indexOf('.mp4') !== -1 ? 'html5' : 'youtube'}
        videoId={video}
        sources={[
          { src: video, type: 'video/mp4' }
        ]}
        urls={{
          youtube: {
            api: 'https://noembed.com/embed?url={0}'
          }
        }}
      />
    </div>
  )

  ColumnContent = ({ items }, index) => (
    <div className='row__content-cont'>
      {items?.map(({ content }, i) => (
        <div className={'row__content'} key={i}>
          {content && parse(content)}
        </div>
      ))}
    </div>
  )

  ApplicationGallery = ({ items }) => {
    return <ApplicationGallery items={items} />
  }

  renderTabs() {
    let { tabs } = this.props

    if (!tabs?.length) return null

    if (tabs?.length === 1) {
      return (
        <div className='tabbed-content__single'>
          { tabs.map(this.renderTab) }
        </div>
      )
    }

    return (
      <Tabs>
        <TabList>
          {tabs?.map((el, i) => {
            return (
              <Tab key={i}>
                {el.tabTitle}
              </Tab>
            )
          })}
        </TabList>

        {tabs?.map((el, i) => (
          <TabPanel key={i}>
            {this.renderTab(el, i)}
          </TabPanel>
        ))}
      </Tabs>
    )
  }

  render() {

    let { title, style } = this.props

    return (
      <section className={`tabbed-content ${style ? 'tabbed-content--dark' : ''}`}>
        <Fade bottom distance={'40px'}>
          <div className='tabbed-content__inner'>
            <div className='tabbed-content__content'>

              {title && (
                <h2 className='title'>
                  {parse(title)}
                </h2>
              )}

              {this.renderTabs()}

            </div>
          </div>
        </Fade>
      </section>
    )
  }
}

TabbedContent.defaultProps = {
  title: ``,
  tabs: [],
}

export default TabbedContent
